var _defs, _rect, _circle, _circle2, _g, _text, _text2, _text3, _text4, _g2, _rect2, _text5, _text6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCover(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 900,
    viewBox: "0 0 1600 900",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#060a14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#0b1324"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowRed",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EF4444",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EF4444",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowBlue",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#60a5fa",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#60a5fa",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hairline",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EF4444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#60a5fa",
    stopOpacity: 0.4
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 900,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1280,
    cy: 190,
    r: 420,
    fill: "url(#glowRed)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 780,
    r: 360,
    fill: "url(#glowBlue)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#ffffff",
    strokeOpacity: 0.035,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 150 H1600 M0 300 H1600 M0 450 H1600 M0 600 H1600 M0 750 H1600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 0 V900 M400 0 V900 M600 0 V900 M800 0 V900 M1000 0 V900 M1200 0 V900 M1400 0 V900"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 160,
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    letterSpacing: 4,
    fontWeight: 700,
    fill: "#EF4444"
  }, "\n    SECURITY RESEARCH &#183; RUNTIME ADVISORY\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 96,
    y: 255,
    fontFamily: "Arial, sans-serif",
    fontSize: 88,
    fontWeight: 800,
    fill: "#f8fafc",
    letterSpacing: -1
  }, "\n    PHP2Shell\n  ")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 305,
    fontFamily: "Arial, sans-serif",
    fontSize: 30,
    fontWeight: 600,
    fill: "#e2e8f0"
  }, "\n    When a fatal error becomes remote code execution\n  ")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 340,
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fill: "#94a3b8"
  }, "\n    CVE-2026-109618 &#183; CVE-2026-109619 \u2014 native PHP runtime, not a CMS plugin\n  ")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "Arial, sans-serif"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 420,
    width: 330,
    height: 110,
    rx: 12,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#ffffff",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 463,
    fontSize: 40,
    fontWeight: 800,
    fill: "#EF4444"
  }, "9.2"), /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 492,
    fontSize: 18,
    fill: "#94a3b8"
  }, "CVSS v4.0 \u2014 critical, two"), /*#__PURE__*/React.createElement("text", {
    x: 126,
    y: 514,
    fontSize: 18,
    fill: "#94a3b8"
  }, "memory-safety CVEs"), /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 420,
    width: 330,
    height: 110,
    rx: 12,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#ffffff",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 463,
    fontSize: 40,
    fontWeight: 800,
    fill: "#fb923c"
  }, "17 Oct"), /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 492,
    fontSize: 18,
    fill: "#94a3b8"
  }, "first attempted exploitation \u2014"), /*#__PURE__*/React.createElement("text", {
    x: 486,
    y: 514,
    fontSize: 18,
    fill: "#94a3b8"
  }, "before the public patch"), /*#__PURE__*/React.createElement("rect", {
    x: 820,
    y: 420,
    width: 330,
    height: 110,
    rx: 12,
    fill: "#ffffff",
    fillOpacity: 0.05,
    stroke: "#ffffff",
    strokeOpacity: 0.1
  }), /*#__PURE__*/React.createElement("text", {
    x: 846,
    y: 463,
    fontSize: 40,
    fontWeight: 800,
    fill: "#60a5fa"
  }, "mod_php"), /*#__PURE__*/React.createElement("text", {
    x: 846,
    y: 492,
    fontSize: 18,
    fill: "#94a3b8"
  }, "unauthenticated RCE"), /*#__PURE__*/React.createElement("text", {
    x: 846,
    y: 514,
    fontSize: 18,
    fill: "#94a3b8"
  }, "confirmed; FPM conditional"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 590,
    width: 1400,
    height: 2,
    fill: "url(#hairline)",
    opacity: 0.6
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 640,
    fontFamily: "Arial, sans-serif",
    fontSize: 22,
    fill: "#64748b"
  }, "\n    Patch the runtime, not just the application \u2014 WAF rules and session tweaks only reduce selected paths.\n  ")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 690,
    fontFamily: "Arial, sans-serif",
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: 2,
    fill: "#475569"
  }, "\n    CYBERMON SECURITY RESEARCH\n  ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCover);
export default __webpack_public_path__ + "static/media/cover.6881983fbe1b30ed1cb7a76eab7a4fc5.svg";
export { ForwardRef as ReactComponent };